module.exports = __webpack_public_path__ + "static/media/bell-school-slash.5d8b462c.svg";